import Deprecated from '../../core/Deprecated';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS } from '../../application-core/constants';
import OntologyLink from '../OntologyLink';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SearchDropDown from '../../core/SearchDropDown';
import GS from '../../grafsync/grafsync';
import { Typography } from '@material-ui/core';

class ProjectOntologySearch extends Component {

  onFoundResource = (id, result) => {
    if (result.isDefinedBy || result.visibility) {
      // Find the first loaded ontology
      // Visibility first because isDefinedBy maybe be different to ontology
      const ontology = result.visibility || result.isDefinedBy;
      const foundOntology = GS.isLoaded(ontology, this.props.graph);
      if (foundOntology) {
        let view = "class";
        if (result.type.includes("ObjectProperty")) {
          view = "objectProperty";
        }
        else if (result.type.includes("DatatypeProperty")) {
          view = "datatypeProperty";
        }
        else if (result.type.includes("AnnotationProperty")) {
          view = "annotationProperty";
        }

        const link = APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/ontology#project=' +
          this.props.project + "&ontology=" + ontology + "&view=" + view + "&" + view + "=" + id;

        this.props.history.push(link);
      }
    }
  };

  render() {

    const { defaultLang, graph } = this.props;

    return (
      <div style={{ height: 40, maxWidth: 400, marginBottom: 12, overflow: 'visible' }}>
        <SearchDropDown
          dataTest="find-ontology"
          search={(value, lang) => {
            return {
              search: [{
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: [
                  "http://www.w3.org/2002/07/owl#Class",
                  "http://www.w3.org/2002/07/owl#AnnotationProperty",
                  "http://www.w3.org/2002/07/owl#DatatypeProperty",
                  "http://www.w3.org/2002/07/owl#ObjectProperty"
                ]
              },
              {
                predicate: [
                  "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
                  "https://grafsync.graphifi.com/schema/gs/visibility"
                ]
              },
              {
                predicate: ["http://www.w3.org/2000/01/rdf-schema#label"],
                value: value,
                isExactMatch: false
              }],
              exclude: [
                "https://graphifi.com/schema/xowl/topAnnotationProperty",
                "http://www.w3.org/2002/07/owl#topObjectProperty",
                "http://www.w3.org/2002/07/owl#topDataProperty",
                "http://www.w3.org/2002/07/owl#Thing"
              ],
              graph: [graph],
              language: lang,
              predicates: [
                "http://www.w3.org/2000/01/rdf-schema#label",
                "http://www.w3.org/2002/07/owl#deprecated",
                "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
                "https://grafsync.graphifi.com/schema/gs/visibility"
              ]
            };
          }}
          sortProp="label"
          suppressMessages={true}
          listSecondIcon={(result) => {
            if (result.deprecated) return <Deprecated />;
            return null;
          }}
          listDisplay={(result, lang) => {
            const ontology = result.visibility || result.isDefinedBy;
            let viewType = "Class";
            if (result.type.includes("ObjectProperty")) {
              viewType = "Object Property";
            }
            else if (result.type.includes("DatatypeProperty")) {
              viewType = "Datatype Property";
            }
            else if (result.type.includes("AnnotationProperty")) {
              viewType = "Annotation Property";
            }
            return <div>
              <div data-test="result-label">
                <Typography variant="body2">
                  <span style={{ wordBreak: 'break-word' }}>
                    {result.label[lang] ?
                      result.label[lang]
                      :
                      result.id
                    }
                  </span>
                </Typography>
              </div>
              <Typography data-test="result-type" variant="caption">{viewType}</Typography>
              {ontology &&
                <div>
                  <OntologyLink iconColor="#808080" key={ontology} id={ontology} handleNotAvailable={true} graph={graph} defaultLang={defaultLang} />
                </div>
              }
            </div>;
          }}
          listSelectionDisplay={(result, lang) => {
            if (result.label && result.label[lang]) {
              return result.label[lang];
            }
            else return result.id;
          }}
          title="Find a project class or property"
          lang={defaultLang}
          chosen={this.onFoundResource} />
      </div>
    );
  }

}

ProjectOntologySearch.propTypes = {
  project: PropTypes.string.isRequired,
  history: PropTypes.object,
  graph: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withRouter(ProjectOntologySearch);